import { useState } from "react";

interface AuthFormInputProps {
  id: string;
  type: "email" | "password";
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  mode: "signin" | "signup" | "reset" | "update" | "confirmation";
}

export const AuthFormInput = ({ 
  id, 
  type, 
  value, 
  onChange, 
  required = true,
  mode 
}: AuthFormInputProps) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {type === "email" ? "Email address" : 
         mode === "update" ? "New Password" : "Password"}
      </label>
      <input
        id={id}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-cso-600 focus:border-cso-600 sm:text-sm"
      />
      {(mode === "signup" || mode === "update") && type === "password" && (
        <p className="mt-1 text-sm text-gray-500">
          Password must contain at least one lowercase letter, one uppercase letter, and one number
        </p>
      )}
    </div>
  );
};